/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */


import React from 'react';
import { Input } from 'reactstrap';
import ValueSlider from './ValueSlider';
import { renderInputGroup } from './InputGroup';
import { InputGroupPrePend } from './InputGroupPrePend'
import { BaseInputProps } from './InputProps';
import { InputHelperText } from './InputHelperText';

export default function NumberInput(props: BaseInputProps) {
  const {
    handleFocus,
    handleValueChange,
    handleUnitChange,
    universalTracker,
    questionValue,
    isDisabled,
    placeholder,
    inputMessage,
  } = props;

  const disabled = Boolean(isDisabled?.(props));
  const value = questionValue ?? '';
  const utrId = universalTracker.getId();
  const invalidMessage = inputMessage?.[utrId];
  const isInvalid = !!invalidMessage;

  const min = universalTracker.getMin();
  const max = universalTracker.getMax();

  if (universalTracker.isPercentage() || universalTracker.hasMinAndMax()) {
    return (
      <ValueSlider
        value={value}
        universalTracker={universalTracker}
        invalidMessage={invalidMessage}
        disabled={disabled}
        placeholder={placeholder}
        handleChange={handleValueChange}
        min={min}
        max={max}
      />
    );
  }

  return <div className='input-group has-validation mb-3'>
    {InputGroupPrePend({ ...props, isInvalid })}
    <Input
      type='number'
      placeholder={placeholder}
      autoComplete='off'
      className={isInvalid ? '' : 'styled-input'}
      name={utrId}
      value={value}
      aria-describedby='suffix'
      disabled={disabled}
      required={true}
      onFocus={handleFocus}
      onClick={handleFocus}
      invalid={isInvalid}
      onWheel={e => e.currentTarget.blur()}
      onChange={(e) => handleValueChange({ value : e.target.value, min, max })}/>
    {renderInputGroup({ ...props, isDisabled, isInvalid, handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => handleUnitChange(e.target.value) })}
    <InputHelperText invalidMessage={invalidMessage} universalTracker={universalTracker} />
  </div>;
}
